/// <amd-module name="Repos/PullRequestMentionAutocomplete/PullRequestAutocompleteUtility" />
import { PullRequestMention } from "./Contracts";
import { searchString, htmlEncode, SearchBehavior } from "Mention/Autocomplete/AutocompleteUtility";
import { uniqueSort } from "VSS/Platform/Util/Array";
import { ISuggestionSearchResult as ISearchResult } from "Mention/Autocomplete/Contracts";

export function compareMentions(a: ISearchResult<PullRequestMention>, b: ISearchResult<PullRequestMention>) {
    return a && a.original && b && b.original && a.original.id - b.original.id;
}

export function union<T>(arrayA: T[], arrayB: T[], comparer: { (a: T, b: T): number }): T[] {
    var result: any[];

    if (!arrayB || arrayB.length === 0) {
        return arrayA;
    }

    result = arrayA.concat(arrayB);
    uniqueSort(result, comparer);

    return result;
}

export function searchHighlightedMention(query: string, pr: PullRequestMention): PullRequestMention {
    let highlightedPullRequest = pr;
    let highlightSubstitutionPattern = `<span class="mention-autocomplete-highlight">$&</span>`; // TODO: constant
    let terms = query
        .split(/\s+/)
        .filter(term => !!term)
        .map(term => htmlEncode(term));
    let idSearchResult = searchString(pr.id.toString(), terms, SearchBehavior.Prefix, highlightSubstitutionPattern);
    let titleSearchResult = searchString(htmlEncode(pr.title), terms, SearchBehavior.Contains, highlightSubstitutionPattern);
    let allTermsFound: boolean = true;
    terms.forEach(term => {
        let foundTerm = idSearchResult.found[term] || titleSearchResult.found[term];
        if (!foundTerm) {
            allTermsFound = false;
        }
    });

    if (allTermsFound) {
        highlightedPullRequest = {
            id: pr.id,
            title: titleSearchResult.highlightedSource,
            url: pr.url
        };
    }

    return highlightedPullRequest;
}
